import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const version = {
  namespaced: true,
  state: {
    back: ''
  },
  getters,
  mutations,
  actions
};